import api from '@/api';

const resource = 'merenda/segmento-estoque';

export default {
  criarSegmentoEstoque( data ) {
    return api.post( `${resource}`, data );
  },

  editarSegmentoEstoque( data ) {
    return api.put( `${resource}/${data.identificadorsegmentoestoqueescola}`, data);
  },

  deletarSegmentoEstoque( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarSegmentosEstoque(data) {
    return api.get( `${resource}`,  {
      params: data
    });
  }
};
